import { useState } from "react";
import { useParams } from "react-router";
import { useI18n } from "i18n";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import EventContextProvider from "modules/event/eventView/EventViewContext";
import { PAGES, usePageTracking } from "modules/tracking";
import { WhiteLabelSettingsLoader } from "modules/settings/components/WhiteLabelSettingsLoader";
import { TicketLoader } from "modules/ticketing/components/TicketLoader";
import EventAuthChecker from "./EventAuthChecker";
import EventLanding from "./components/EventLandingPageContainer/EventLandingPageContainer";

type EventLandingParams = {
  eventCode: string;
};

const EventLandingPage = (): JSX.Element => {
  const { t } = useI18n(["eventLanding"]);
  const [redirectingToSSO, setRedirectingToSSO] = useState(false);
  const { eventCode } = useParams<EventLandingParams>();

  usePageTracking(PAGES.EVENT_LANDING_PAGE);

  return (
    <EventContextProvider eventCode={eventCode}>
      <WhiteLabelSettingsLoader />
      <TicketLoader />
      <EventAuthChecker setRedirectingToSSO={setRedirectingToSSO} />
      {redirectingToSSO && (
        <div className="svg-map-loader loading-div">
          <PageLoader
            message={t("eventLanding:getting.logged.in")}
            data-testid="page-loading"
          />
        </div>
      )}
      <EventLanding />
    </EventContextProvider>
  );
};

export default EventLandingPage;
